import { useEffect } from 'react'

import { ImagesPreloader, ImageToPreload } from '@sketch/components'

import CommunityImageSrc from '@sketch/icons/community-illustration@1x.png'
import CommunityRetinaImageSrc from '@sketch/icons/community-illustration@2x.png'

export const usePreloadCreateProfileImage = () => {
  useEffect(() => {
    const imagesToPreload: ImageToPreload[] = [
      {
        src: CommunityImageSrc,
        srcset: [
          { path: CommunityImageSrc, scale: 1 },
          { path: CommunityRetinaImageSrc, scale: 2 },
        ],
      },
    ]

    new ImagesPreloader(imagesToPreload, (path: string) => path)
  }, [])
}
